import { Grid, GridProps, Text } from '@chakra-ui/react';
import React from 'react';

type CounterProps = {
    value: number,
    onValueChange: (v: number) => void,
} & GridProps & React.RefAttributes<HTMLDivElement>

export const Counter: React.FC<CounterProps> = ({
    value,
    onValueChange,
    ...props
}) => (
    <Grid templateColumns="auto 1fr auto" {...props}>
        <Grid onClick={() => onValueChange(value - 1)} padding="1rem" cursor="pointer">
            <Text margin="auto" fontWeight={900}>
                –
            </Text>
        </Grid>
        <Grid border="1px solid #000000" overflow="hidden" padding="1rem" width="3rem">
            <Text margin="auto" fontWeight={900}>
                {value}
            </Text>
        </Grid>
        <Grid onClick={() => onValueChange(value + 1)} padding="1rem" cursor="pointer">
            <Text margin="auto" fontWeight={900}>
                +
            </Text>
        </Grid>
    </Grid>
);
